// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

:focus-visible {
  outline: 2px solid var(--ion-color-primary, #3880ff);
  outline-offset: 2px;
  border-radius: 4px;
}

ion-icon[role=button]:focus-visible,
ion-button:focus-visible {
  outline: 3px solid var(--ion-color-primary, #3880ff);
  outline-offset: 2px;
  box-shadow: 0 0 0 1px rgba(56, 128, 255, 0.2);
}

ion-button:hover:not([disabled]) {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.skip-link {
  position: absolute;
  top: -40px;
  left: 6px;
  background: var(--ion-color-primary);
  color: white;
  padding: 8px;
  text-decoration: none;
  border-radius: 4px;
  z-index: 9999;
}
.skip-link:focus {
  top: 6px;
}

swiper-container {
  height: 100%;
}

.margin-top-value {
  margin-top: 10px;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  overflow: auto;
}

ion-slide {
  width: 100% !important;
  padding: 10px;
}
ion-slide > ion-col {
  overflow: auto;
  top: 0;
  bottom: 0;
  position: absolute;
  padding: 20px;
  text-align: left;
}

@media (min-width: 991px) {
  ion-content {
    height: 80%;
  }
}

.form-row {
  padding: 5px 25px 20px;
}

.slots-row {
  padding: 0px 25px 20px;
  display: flex;
  flex-direction: column;
}

.form-card {
  background-color: var(--background-color);
  padding: 12px 6px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.phone-item {
  border: none;
}
.phone-item ion-input:first-child {
  margin-right: 10px;
}
.phone-item ion-input {
  margin-bottom: 5px;
  border-bottom: 1px solid var(--ion-color-dark);
}

.label-error {
  color: #d32f2f;
  font-weight: 600;
}

ion-card {
  margin: 0;
  padding: 12px;
  border-radius: var(--custom-border-radius);
  text-align: initial;
  --color: var(--ion-color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
  box-shadow: 0px 0px 45px 0px rgba(0, 0, 0, 0.1019607843);
}
ion-card:focus-within {
  box-shadow: 0px 0px 45px 0px rgba(0, 0, 0, 0.1019607843), 0 0 0 2px var(--ion-color-primary);
}
ion-card:first-of-type {
  margin-bottom: 10px;
}
ion-card ion-card-header {
  background: white;
  color: var(--ion-color-black);
  padding: 0;
  padding-bottom: 8px;
  border-bottom: 0.3px solid rgba(126, 167, 105, 0.4509803922);
}
ion-card ion-card-header .separator {
  margin-block: 20px;
}
ion-card ion-card-header ion-button {
  --background: transparent;
  --color: #54504c;
  text-transform: none;
}
ion-card ion-card-content {
  padding: 10px 0px 0px 0px;
  line-break: auto !important;
}
ion-card ion-card-content:first-of-type {
  border: none;
}
ion-card ion-card-content .padding-card {
  padding: 10px;
}
ion-card ion-card-title {
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
  font-size: 18px;
}
ion-card .icon-edit {
  zoom: 1.3;
  cursor: pointer;
  transition: all 0.2s ease;
}
ion-card .icon-edit:hover {
  transform: scale(1.1);
  color: var(--ion-color-primary-shade);
}
ion-card .icon-edit:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
  border-radius: 4px;
}
ion-card ion-col {
  padding: 5px 0px;
  color: var(--ion-color-secondary);
  font-size: 14px;
}

dl {
  margin: 0;
}
dl .info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}
dl .info-row dt, dl .info-row dd {
  margin: 0;
  padding: 2px 0;
}
dl .info-row dt {
  font-weight: 600;
  flex: 0 0 auto;
  margin-right: 10px;
}
dl .info-row dd {
  flex: 1;
  text-align: right;
}

.left-col {
  text-align: left;
  font-family: AppFontBold, sans-serif;
}

.right-col {
  font-family: AppFont, sans-serif;
  text-align: right;
}

.border-top-light-blue {
  border-top: 0.5px solid #e2dcd5;
}
.border-top-light-blue h3 {
  margin-top: 10px;
  place-self: center;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
}

ion-chip {
  margin: 0;
  margin-left: auto;
  background: var(--ion-color-primary);
  padding: 2px 10px;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: unset;
  width: -moz-fit-content;
  width: fit-content;
}
ion-chip ion-label {
  font-family: AppFontBold;
  font-size: 9px;
  line-height: 10px;
  letter-spacing: 0em;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
}
@media (min-width: 991px) {
  ion-chip ion-label {
    font-size: 12px;
    line-height: 14px;
  }
}

.card-content-md {
  font-weight: unset;
}

.adds-price {
  padding-left: 5px;
  color: var(--ion-color-medium);
}

.order-at-header {
  text-align: left;
  margin: 10px;
  margin-left: 0px;
  font-size: 20px;
  line-height: 24px;
  text-transform: capitalize;
  font-family: AppFontBold, sans-serif;
  font-weight: bold;
  color: var(--ion-color-secondary);
}

ion-label {
  text-align: left;
}
ion-label[for] {
  cursor: pointer;
}
ion-label[for]:hover {
  color: var(--ion-color-primary);
}

.padding {
  padding: 25px;
}

.privacy {
  font-family: OpenSans, sans-serif;
  font-size: 11px;
  color: var(--ion-color-black);
}

.phoneCountry {
  max-width: 15%;
}
@media (min-width: 991px) {
  .phoneCountry {
    max-width: 10%;
  }
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  height: 8px;
  background-size: 7px 100%;
}
.separator--wide .line {
  background-size: 8px 100%;
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 10px 17px;
}
.footer .sub-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 19px;
}
.footer .sub-total .sub-total-title {
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--ion-color-secondary);
}
.footer .sub-total .sub-total-sum {
  font-family: AppFontBold;
  font-size: 14px;
  letter-spacing: 0em;
  text-align: right;
  color: var(--ion-color-secondary);
}
.footer .border-line {
  width: 100%;
  height: 3px;
  margin-top: 13px;
}
.footer .total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 19px;
}
.footer .total .total-title {
  font-family: AppFontBold;
  font-size: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--ion-color-secondary);
}
.footer .total .total-sum {
  font-family: AppFontBold;
  font-size: 18px;
  letter-spacing: 0em;
  text-align: right;
  color: var(--ion-color-secondary);
}

.button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}
.button-row .footer-btn {
  min-height: 46px;
  height: 46px;
  width: 100%;
  --padding-start: 5px;
  --padding-end: 5px;
  --padding-top: 5px;
  --padding-bottom: 5px;
  position: relative;
}
.button-row .footer-btn[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
.button-row .footer-btn[disabled]:focus-visible {
  outline: 2px solid var(--ion-color-medium);
}
.button-row .footer-btn:not([disabled]):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}
.button-row .footer-btn .footer-btn-text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: center;
  color: #fff;
}
.button-row .footer-btn .button-img {
  width: 35px;
  height: 35px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
}

.footer-info-title {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0px;
}

ion-radio-group {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #000;
}
ion-radio-group ion-radio {
  --border-width: 1px;
  --border-color: #000;
  --border-color-checked: #000;
  --background-checked: transparent;
  --color-checked: #000;
  --color: #000;
}
ion-radio-group ion-radio::part(label) {
  text-overflow: initial;
  white-space: initial;
}
ion-radio-group ion-radio:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
ion-radio-group .radio-checked::part(mark) {
  transform: scale3d(1.4, 1.4, 1);
}
ion-radio-group .additional-info {
  display: block;
  margin-top: 12px;
  font-family: AppFont;
  font-size: 10px;
  line-height: 13px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #1a1a18;
}

.main-overview-row {
  padding: 16px 25px;
}

.articles-row ~ :not(.tip-row) {
  margin-bottom: 12px;
}

.tip-row {
  margin-bottom: 12px;
}

app-tip {
  display: block;
  margin-bottom: 12px;
}

.article-row {
  margin-bottom: 8px;
  list-style: none;
}

.name-col {
  display: flex;
  align-items: center;
}
.name-col h3 {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  text-align: left;
  color: var(--ion-color-secondary);
}
.name-col ion-icon {
  zoom: 1.2;
  margin-right: 5px;
}

.article-price {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  line-height: 15px;
  text-align: right;
  color: var(--ion-color-secondary);
}

.total-row {
  margin-top: 20px;
}
.total-row .total-title {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #000;
  margin: 0;
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .total-row .total-title {
    font-size: 16px;
    line-height: 20px;
  }
}
.total-row .price {
  font-family: AppFontBold;
  font-size: 15px;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: right;
  color-scheme: #000;
  margin: 0;
}
@media (min-width: 991px) {
  .total-row .price {
    font-size: 16px;
    line-height: 20px;
  }
}

.container, .custom_phone {
  position: relative;
  margin-bottom: 20px;
}
.container ion-label, .custom_phone ion-label {
  color: var(--ion-color-secondary);
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  margin-bottom: 10px;
  display: block;
}
.container ion-label::after, .custom_phone ion-label::after {
  content: "";
}
.container ion-label[aria-required=true]::after, .container ion-label.required::after, .custom_phone ion-label[aria-required=true]::after, .custom_phone ion-label.required::after {
  content: " *";
  color: #d32f2f;
}

.input-error {
  --color: #d32f2f !important;
  --placeholder-color: #d32f2f !important;
  margin-bottom: 0 !important;
  font-weight: 600;
}

.error-text {
  margin: 4px 0;
  width: 100%;
  color: #d32f2f;
  font-size: 12px;
  font-weight: 500;
}
.error-text[role=alert] {
  display: block;
}

.input_group-1 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
}
.input_group-1 .lock-icon {
  height: 12px;
  color: var(--ion-color-medium);
}
@media (min-width: 991px) {
  .input_group-1 .lock-icon {
    margin: 2px -10px 15px 5px;
  }
}
.input_group-1--1 {
  width: 70% !important;
  margin-right: 0;
}
.input_group-1--2 {
  margin: 0px 7px 20px;
  width: 30% !important;
}

.input_group-2 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0 0px;
  gap: 8px;
}
.input_group-2 .lock-icon {
  height: 12px;
  color: var(--ion-color-medium);
}
@media (min-width: 991px) {
  .input_group-2 .lock-icon {
    margin: 2px -10px 15px 5px;
  }
}
.input_group-2--1 {
  width: 30%;
  margin-right: 0;
}
.input_group-2--2 {
  width: 70%;
  margin: 0 7px 20px;
}

.option-name {
  list-style: none;
}
.option-name ion-col {
  font-size: 12px !important;
  color: #C1C1C1;
  padding: 0px;
}

ion-item {
  --padding-start: 18px;
  --min-height: 45px;
  --border-radius: 16px;
  --background: white;
  --inner-border-width: 0px;
  border: 1px solid #CBD5E1;
  margin-bottom: 2px;
  border-radius: 16px;
  margin-top: 10px;
  font-family: AppFontLight;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;
  transition: all 0.2s ease;
}
ion-item:last-of-type {
  margin-bottom: 0;
}
ion-item:focus-within {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 2px rgba(56, 128, 255, 0.2);
}
ion-item[aria-invalid=true] {
  border-color: #d32f2f;
}
ion-item[aria-invalid=true]:focus-within {
  border-color: #d32f2f;
  box-shadow: 0 0 0 2px rgba(211, 47, 47, 0.2);
}
ion-item.ion-info {
  border-color: var(--ion-color-warning);
}
ion-item.ion-info:focus-within {
  border-color: var(--ion-color-warning);
  box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.2);
}
ion-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

ion-input {
  font-family: AppFont, sans-serif;
  color: var(--ion-color-secondary);
  font-size: 16px;
}
ion-input:focus-visible {
  outline: none;
}
ion-input[readonly] {
  cursor: not-allowed;
  color: var(--ion-color-medium);
}

.inputs_container__title {
  font-size: 16px;
}

.btn_wrapper {
  margin: 0px;
  text-align: center;
}
.btn_wrapper p {
  font-size: 12px;
  text-align: center;
  color: var(--ion-color-primary);
  margin-bottom: 8px;
}
.btn_wrapper .check_btn {
  margin-top: 10px;
  width: 80% !important;
  font-size: 14px;
  --background: white;
  border: 3px solid var(--ion-color-primary);
  color: var(--ion-color-primary);
  transition: all 0.2s ease;
}
.btn_wrapper .check_btn:hover:not([disabled]) {
  background: var(--ion-color-primary);
  color: white;
  transform: translateY(-1px);
}
.btn_wrapper .check_btn:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}

ion-spinner[aria-label]::after {
  content: attr(aria-label);
  position: absolute;
  left: -9999px;
}

.error_container {
  min-height: 20px;
}
.error_container ion-note {
  transition: opacity 0.2s ease;
}
.error_container ion-note:not(.visible) {
  opacity: 0;
  height: 0;
  overflow: hidden;
}
.error_container ion-note.visible {
  opacity: 1;
  height: auto;
}

@media (prefers-contrast: high) {
  ion-item {
    border-width: 2px;
  }
  .input-error, .error-text {
    --color: #cc0000 !important;
    font-weight: 700;
  }
  :focus-visible {
    outline-width: 3px;
  }
}
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  ion-button:hover:not([disabled]) {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAKA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAFD;;AAMA;EACC,oDAAA;EACA,mBAAA;EACA,kBAAA;AAHD;;AAOA;;EAEC,oDAAA;EACA,mBAAA;EACA,6CAAA;AAJD;;AAQA;EACC,2BAAA;EACA,yCAAA;EACA,yBAAA;AALD;;AASA;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;AAND;AAQC;EACC,QAAA;AANF;;AAUA;EACC,YAAA;AAPD;;AAUA;EACC,gBAAA;AAPD;;AAUA;EACC,sBAAA;EACA,uBAAA;AAPD;;AAUA;EACC,cAAA;AAPD;;AAUA;EACC,sBAAA;EACA,aAAA;AAPD;AAQC;EACC,cAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AANF;;AC7EE;EDuFF;IAEE,WAAA;EAPA;AACF;;AAUA;EACC,sBAAA;AAPD;;AAUA;EACC,sBAAA;EACA,aAAA;EACA,sBAAA;AAPD;;AAUA;EACC,yCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAPD;;AAUA;EACC,YAAA;AAPD;AAQC;EACC,kBAAA;AANF;AAQC;EACC,kBAAA;EACA,8CAAA;AANF;;AAUA;EACC,cAAA;EACA,gBAAA;AAPD;;AAWA;EACC,SAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,+BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;EACA,wDAAA;AARD;AAWC;EACC,4FAAA;AATF;AAYC;EACC,mBAAA;AAVF;AAaC;EACC,iBAAA;EACA,6BAAA;EACA,UAAA;EACA,mBAAA;EAIA,4DAAA;AAdF;AAWE;EACC,kBAAA;AATH;AAaE;EACC,yBAAA;EACA,gBAAA;EACA,oBAAA;AAXH;AAeC;EACC,yBAAA;EACA,2BAAA;AAbF;AAcE;EACC,YAAA;AAZH;AAcE;EACC,aAAA;AAZH;AAgBC;EACC,oCAAA;EACA,iCAAA;EACA,eAAA;AAdF;AAiBC;EACC,SAAA;EACA,eAAA;EACA,yBAAA;AAfF;AAiBE;EACC,qBAAA;EACA,qCAAA;AAfH;AAkBE;EACC,2CAAA;EACA,mBAAA;EACA,kBAAA;AAhBH;AAoBC;EACC,gBAAA;EACA,iCAAA;EACA,eAAA;AAlBF;;AAuBA;EACC,SAAA;AApBD;AAsBC;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AApBF;AAsBE;EACC,SAAA;EACA,cAAA;AApBH;AAuBE;EACC,gBAAA;EACA,cAAA;EACA,kBAAA;AArBH;AAwBE;EACC,OAAA;EACA,iBAAA;AAtBH;;AA2BA;EACC,gBAAA;EACA,oCAAA;AAxBD;;AA2BA;EACC,gCAAA;EACA,iBAAA;AAxBD;;AA2BA;EACC,+BAAA;AAxBD;AAyBC;EACC,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;AAvBF;;AA2BA;EACC,SAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;AAxBD;AA0BC;EACC,wBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;AAxBF;ACzPE;ED0QD;IASE,eAAA;IACA,iBAAA;EAtBD;AACF;;AA0BA;EACC,kBAAA;AAvBD;;AA0BA;EACC,iBAAA;EACA,8BAAA;AAvBD;;AA0BA;EACC,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,oCAAA;EACA,iBAAA;EACA,iCAAA;AAvBD;;AA0BA;EACC,gBAAA;AAvBD;AA0BC;EACC,eAAA;AAxBF;AA0BE;EACC,+BAAA;AAxBH;;AA6BA;EACC,aAAA;AA1BD;;AA6BA;EACC,iCAAA;EACA,eAAA;EACA,6BAAA;AA1BD;;AA6BA;EACC,cAAA;AA1BD;AC5SE;EDqUF;IAGE,cAAA;EAxBA;AACF;;AA2BA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAxBD;AA0BC;EACC,WAAA;EACA,yBAAA;AAxBF;AA0BC;EACC,yBAAA;AAxBF;;AA6BA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;AA1BD;AA4BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AA1BF;AA4BE;EACC,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;AA1BH;AA4BE;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;AA1BH;AA8BC;EACC,WAAA;EACA,WAAA;EACA,gBAAA;AA5BF;AA+BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AA7BF;AA+BE;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;AA7BH;AA+BE;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;AA7BH;;AAkCA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AA/BD;AAiCC;EACC,gBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AA/BF;AAkCE;EACC,YAAA;EACA,mBAAA;AAhCH;AAkCG;EACC,0CAAA;AAhCJ;AAoCE;EACC,2BAAA;EACA,yCAAA;AAlCH;AAqCE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAnCH;AAsCE;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;AApCH;;AAyCA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAtCD;;AA0CA;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAvCD;AAyCC;EACC,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qBAAA;EACA,aAAA;AAvCF;AAyCE;EACC,sBAAA;EACA,oBAAA;AAvCH;AA0CE;EACC,2CAAA;EACA,mBAAA;AAxCH;AA4CC;EACC,+BAAA;AA1CF;AA6CC;EACC,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AA3CF;;AA+CA;EACC,kBAAA;AA5CD;;AA+CA;EACC,mBAAA;AA5CD;;AA+CA;EACC,mBAAA;AA5CD;;AA+CA;EACC,cAAA;EACA,mBAAA;AA5CD;;AA+CA;EACC,kBAAA;EACA,gBAAA;AA5CD;;AA+CA;EACC,aAAA;EACA,mBAAA;AA5CD;AA6CC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;AA3CF;AA6CC;EACC,SAAA;EACA,iBAAA;AA3CF;;AA+CA;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iCAAA;AA5CD;;AA+CA;EACC,gBAAA;AA5CD;AA8CC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AA5CF;AC9gBE;EDkjBD;IAUE,eAAA;IACA,iBAAA;EA1CD;AACF;AA6CC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AA3CF;AC7hBE;EDikBD;IASE,eAAA;IACA,iBAAA;EAzCD;AACF;;AA8CA;EACC,kBAAA;EACA,mBAAA;AA3CD;AA6CC;EACC,iCAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,cAAA;AA3CF;AA8CE;EACC,WAAA;AA5CH;AA+CE;EAEC,aAAA;EACA,cAAA;AA9CH;;AAoDA;EACC,2BAAA;EACA,uCAAA;EACA,2BAAA;EACA,gBAAA;AAjDD;;AAoDA;EACC,aAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjDD;AAoDC;EACC,cAAA;AAlDF;;AAuDA;EACC,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;AApDD;AAsDC;EACC,YAAA;EACA,8BAAA;AApDF;ACnlBE;EDqoBD;IAIE,0BAAA;EAlDD;AACF;AAqDC;EACC,qBAAA;EACA,eAAA;AAnDF;AAsDC;EACC,oBAAA;EACA,qBAAA;AApDF;;AAwDA;EACC,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,cAAA;EACA,QAAA;AArDD;AAuDC;EACC,YAAA;EACA,8BAAA;AArDF;AC5mBE;ED+pBD;IAIE,0BAAA;EAnDD;AACF;AAsDC;EACC,UAAA;EACA,eAAA;AApDF;AAuDC;EACC,UAAA;EACA,kBAAA;AArDF;;AAyDA;EACC,gBAAA;AAtDD;AAwDC;EACC,0BAAA;EACA,cAAA;EACA,YAAA;AAtDF;;AA2DA;EACC,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAxDD;AA0DC;EACC,gBAAA;AAxDF;AA4DC;EACC,sCAAA;EACA,6CAAA;AA1DF;AA8DC;EACC,qBAAA;AA5DF;AA8DE;EACC,qBAAA;EACA,4CAAA;AA5DH;AAiEC;EACC,sCAAA;AA/DF;AAiEE;EACC,sCAAA;EACA,4CAAA;AA/DH;AAoEC;EACC,YAAA;EACA,mBAAA;EACA,yBAAA;AAlEF;;AAuEA;EACC,gCAAA;EACA,iCAAA;EACA,eAAA;AApED;AAsEC;EACC,aAAA;AApEF;AAuEC;EACC,mBAAA;EACA,8BAAA;AArEF;;AAyEA;EACC,eAAA;AAtED;;AA0EA;EACC,WAAA;EACA,kBAAA;AAvED;AAyEC;EACC,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;AAvEF;AA0EC;EACC,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,+BAAA;EACA,yBAAA;AAxEF;AA0EE;EACC,oCAAA;EACA,YAAA;EACA,2BAAA;AAxEH;AA2EE;EACC,2CAAA;EACA,mBAAA;AAzEH;;AAiFC;EACC,yBAAA;EACA,kBAAA;EACA,aAAA;AA9EF;;AAmFA;EACC,gBAAA;AAhFD;AAkFC;EACC,6BAAA;AAhFF;AAkFE;EACC,UAAA;EACA,SAAA;EACA,gBAAA;AAhFH;AAmFE;EACC,UAAA;EACA,YAAA;AAjFH;;AAuFA;EACC;IACC,iBAAA;EApFA;EAuFD;IACC,2BAAA;IACA,gBAAA;EArFA;EAwFD;IACC,kBAAA;EAtFA;AACF;AA0FA;EACC;IACC,qCAAA;IACA,uCAAA;IACA,sCAAA;EAxFA;EA2FD;IACC,eAAA;EAzFA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n:root {\n\t--ion-padding: 12px;\n}\n\n// Screen reader only utility class\n.sr-only {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tpadding: 0;\n\tmargin: -1px;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\twhite-space: nowrap;\n\tborder: 0;\n}\n\n// Focus styles for better keyboard navigation\n:focus-visible {\n\toutline: 2px solid var(--ion-color-primary, #3880ff);\n\toutline-offset: 2px;\n\tborder-radius: 4px;\n}\n\n// High contrast focus for icons and buttons\nion-icon[role=\"button\"]:focus-visible,\nion-button:focus-visible {\n\toutline: 3px solid var(--ion-color-primary, #3880ff);\n\toutline-offset: 2px;\n\tbox-shadow: 0 0 0 1px rgba(56, 128, 255, 0.2);\n}\n\n// Enhanced button hover states for accessibility\nion-button:hover:not([disabled]) {\n\ttransform: translateY(-1px);\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n\ttransition: all 0.2s ease;\n}\n\n// Skip link for keyboard navigation\n.skip-link {\n\tposition: absolute;\n\ttop: -40px;\n\tleft: 6px;\n\tbackground: var(--ion-color-primary);\n\tcolor: white;\n\tpadding: 8px;\n\ttext-decoration: none;\n\tborder-radius: 4px;\n\tz-index: 9999;\n\t\n\t&:focus {\n\t\ttop: 6px;\n\t}\n}\n\nswiper-container {\n\theight: 100%;\n}\n\n.margin-top-value {\n\tmargin-top: 10px;\n}\n\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\toverflow: auto;\n}\n\nion-slide {\n\twidth: 100% !important;\n\tpadding: 10px;\n\t> ion-col {\n\t\toverflow: auto;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tposition: absolute;\n\t\tpadding: 20px;\n\t\ttext-align: left;\n\t}\n}\n\nion-content {\n\t@include desktop {\n\t\theight: 80%;\n\t}\n}\n\n.form-row {\n\tpadding: 5px 25px 20px;\n}\n\n.slots-row {\n\tpadding: 0px 25px 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.form-card {\n\tbackground-color: var(--background-color);\n\tpadding: 12px 6px;\n\tmargin-top: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.phone-item {\n\tborder: none;\n\tion-input:first-child {\n\t\tmargin-right: 10px;\n\t}\n\tion-input {\n\t\tmargin-bottom: 5px;\n\t\tborder-bottom: 1px solid var(--ion-color-dark);\n\t}\n}\n\n.label-error {\n\tcolor: #d32f2f; // Better contrast red\n\tfont-weight: 600;\n}\n\n// Improved card accessibility\nion-card {\n\tmargin: 0;\n\tpadding: 12px;\n\tborder-radius: var(--custom-border-radius);\n\ttext-align: initial;\n\t--color: var(--ion-color-black);\n\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\toverflow: auto;\n\tword-break: break-word;\n\tbox-shadow: 0px 0px 45px 0px #0000001A;\n\t\n\t// Enhanced focus for card regions\n\t&:focus-within {\n\t\tbox-shadow: 0px 0px 45px 0px #0000001A, 0 0 0 2px var(--ion-color-primary);\n\t}\n\t\n\t&:first-of-type {\n\t\tmargin-bottom: 10px;\n\t}\n\t\n\tion-card-header {\n\t\tbackground: white;\n\t\tcolor: var(--ion-color-black);\n\t\tpadding: 0;\n\t\tpadding-bottom: 8px;\n\t\t.separator {\n\t\t\tmargin-block: 20px;\n\t\t}\n\t\tborder-bottom: 0.3px solid #7EA76973;\n\n\t\tion-button {\n\t\t\t--background: transparent;\n\t\t\t--color: #54504c;\n\t\t\ttext-transform: none;\n\t\t}\n\t}\n\t\n\tion-card-content {\n\t\tpadding: 10px 0px 0px 0px;\n\t\tline-break: auto !important;\n\t\t&:first-of-type {\n\t\t\tborder: none;\n\t\t}\n\t\t.padding-card {\n\t\t\tpadding: 10px;\n\t\t}\n\t}\n\t\n\tion-card-title {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 18px;\n\t}\n\t\n\t.icon-edit {\n\t\tzoom: 1.3;\n\t\tcursor: pointer;\n\t\ttransition: all 0.2s ease;\n\t\t\n\t\t&:hover {\n\t\t\ttransform: scale(1.1);\n\t\t\tcolor: var(--ion-color-primary-shade);\n\t\t}\n\t\t\n\t\t&:focus-visible {\n\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t\tborder-radius: 4px;\n\t\t}\n\t}\n\t\n\tion-col {\n\t\tpadding: 5px 0px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 14px;\n\t}\n}\n\n// Improved definition list styling for better accessibility\ndl {\n\tmargin: 0;\n\t\n\t.info-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: flex-start;\n\t\tmargin-bottom: 8px;\n\t\t\n\t\tdt, dd {\n\t\t\tmargin: 0;\n\t\t\tpadding: 2px 0;\n\t\t}\n\t\t\n\t\tdt {\n\t\t\tfont-weight: 600;\n\t\t\tflex: 0 0 auto;\n\t\t\tmargin-right: 10px;\n\t\t}\n\t\t\n\t\tdd {\n\t\t\tflex: 1;\n\t\t\ttext-align: right;\n\t\t}\n\t}\n}\n\n.left-col {\n\ttext-align: left;\n\tfont-family: AppFontBold, sans-serif;\n}\n\n.right-col {\n\tfont-family: AppFont, sans-serif;\n\ttext-align: right;\n}\n\n.border-top-light-blue {\n\tborder-top: 0.5px solid #e2dcd5;\n\th3 {\n\t\tmargin-top: 10px;\n\t\tplace-self: center;\n\t\tfont-size: 16px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n}\n\nion-chip {\n\tmargin: 0;\n\tmargin-left: auto;\n\tbackground: var(--ion-color-primary);\n\tpadding: 2px 10px;\n\tborder-radius: 28px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: unset;\n\twidth: fit-content;\n\n\tion-label {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 9px;\n\t\tline-height: 10px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t\t@include desktop {\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 14px;\n\t\t}\n\t}\n}\n\n.card-content-md {\n\tfont-weight: unset;\n}\n\n.adds-price {\n\tpadding-left: 5px;\n\tcolor: var(--ion-color-medium);\n}\n\n.order-at-header {\n\ttext-align: left;\n\tmargin: 10px;\n\tmargin-left: 0px;\n\tfont-size: 20px;\n\tline-height: 24px;\n\ttext-transform: capitalize;\n\tfont-family: AppFontBold, sans-serif;\n\tfont-weight: bold;\n\tcolor: var(--ion-color-secondary);\n}\n\nion-label {\n\ttext-align: left;\n\t\n\t// Improved label accessibility\n\t&[for] {\n\t\tcursor: pointer;\n\t\t\n\t\t&:hover {\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n.padding {\n\tpadding: 25px;\n}\n\n.privacy {\n\tfont-family: OpenSans, sans-serif;\n\tfont-size: 11px;\n\tcolor: var(--ion-color-black);\n}\n\n.phoneCountry {\n\tmax-width: 15%;\n\t@include desktop {\n\t\tmax-width: 10%;\n\t}\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t.line {\n\t\theight: 8px;\n\t\tbackground-size: 7px 100%;\n\t}\n\t&--wide .line {\n\t\tbackground-size: 8px 100%;\n\t}\n}\n\n// Enhanced footer accessibility\n.footer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: stretch;\n\tpadding: 10px 17px;\n\t\n\t.sub-total {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tmargin-top: 19px;\n\t\n\t\t.sub-total-title {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 14px;\n\t\t\tletter-spacing: 0em;\n\t\t\ttext-align: left;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\t.sub-total-sum {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tletter-spacing: 0em;\n\t\t\ttext-align: right;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t}\n\t\n\t.border-line {\n\t\twidth: 100%;\n\t\theight: 3px;\n\t\tmargin-top: 13px;\n\t}\n\t\n\t.total {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tmargin-top: 19px;\n\t\n\t\t.total-title {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 18px;\n\t\t\tletter-spacing: 0em;\n\t\t\ttext-align: left;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\t.total-sum {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 18px;\n\t\t\tletter-spacing: 0em;\n\t\t\ttext-align: right;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t}\n}\n\n.button-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-top: 12px;\n\n\t.footer-btn {\n\t\tmin-height: 46px;\n\t\theight: 46px;\n\t\twidth: 100%;\n\t\t--padding-start: 5px;\n\t\t--padding-end: 5px;\n\t\t--padding-top: 5px;\n\t\t--padding-bottom: 5px;\n\t\tposition: relative;\n\t\t\n\t\t// Enhanced accessibility for disabled state\n\t\t&[disabled] {\n\t\t\topacity: 0.6;\n\t\t\tcursor: not-allowed;\n\t\t\t\n\t\t\t&:focus-visible {\n\t\t\t\toutline: 2px solid var(--ion-color-medium);\n\t\t\t}\n\t\t}\n\t\t\n\t\t&:not([disabled]):hover {\n\t\t\ttransform: translateY(-2px);\n\t\t\tbox-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);\n\t\t}\n\t\t\n\t\t.footer-btn-text {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 14px;\n\t\t\tletter-spacing: 0em;\n\t\t\ttext-align: center;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t\n\t\t.button-img {\n\t\t\twidth: 35px;\n\t\t\theight: 35px;\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t}\n\t}\n}\n\n.footer-info-title {\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tline-height: 19px;\n\tletter-spacing: 0px;\n}\n\n// Enhanced radio group accessibility\nion-radio-group {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-bottom: 12px;\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: #000;\n\t\n\tion-radio {\n\t\t--border-width: 1px;\n\t\t--border-color: #000;\n\t\t--border-color-checked: #000;\n\t\t--background-checked: transparent;\n\t\t--color-checked: #000;\n\t\t--color: #000;\n\n\t\t&::part(label) {\n\t\t\ttext-overflow: initial;\n\t\t\twhite-space: initial;\n\t\t}\n\t\t\n\t\t&:focus-visible {\n\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\t}\n\t\n\t.radio-checked::part(mark) {\n\t\ttransform: scale3d(1.4, 1.4, 1);\n\t}\n\n\t.additional-info {\n\t\tdisplay: block;\n\t\tmargin-top: 12px;\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 13px;\n\t\tletter-spacing: 0.01em;\n\t\ttext-align: left;\n\t\tcolor: #1a1a18;\n\t}\n}\n\n.main-overview-row {\n\tpadding: 16px 25px;\n}\n\n.articles-row ~ :not(.tip-row) {\n\tmargin-bottom: 12px;\n}\n\n.tip-row {\n\tmargin-bottom: 12px;\n}\n\napp-tip {\n\tdisplay: block;\n\tmargin-bottom: 12px;\n}\n\n.article-row {\n\tmargin-bottom: 8px;\n\tlist-style: none;\n}\n\n.name-col {\n\tdisplay: flex;\n\talign-items: center;\n\th3 {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n\tion-icon {\n\t\tzoom: 1.2;\n\t\tmargin-right: 5px;\n\t}\n}\n\n.article-price {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 14px;\n\tline-height: 15px;\n\ttext-align: right;\n\tcolor: var(--ion-color-secondary);\n}\n\n.total-row {\n\tmargin-top: 20px;\n\n\t.total-title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 13px;\n\t\tline-height: 16px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\tmargin: 0;\n\t\ttext-transform: uppercase;\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n\n\t.price {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 15px;\n\t\tline-height: 15px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: right;\n\t\tcolor-scheme: #000;\n\t\tmargin: 0;\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n}\n\n// Enhanced form container accessibility\n.container, .custom_phone {\n\tposition: relative;\n\tmargin-bottom: 20px;\n\t\n\tion-label {\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 16px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tmargin-bottom: 10px;\n\t\tdisplay: block;\n\t\t\n\t\t// Required field indicator\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t}\n\t\t\n\t\t&[aria-required=\"true\"]::after,\n\t\t&.required::after {\n\t\t\tcontent: ' *';\n\t\t\tcolor: #d32f2f;\n\t\t}\n\t}\n}\n\n// Enhanced error styling\n.input-error {\n\t--color: #d32f2f !important;\n\t--placeholder-color: #d32f2f !important;\n\tmargin-bottom: 0 !important;\n\tfont-weight: 600;\n}\n\n.error-text {\n\tmargin: 4px 0;\n\twidth: 100%;\n\tcolor: #d32f2f;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\t\n\t// Ensure error text is announced by screen readers\n\t&[role=\"alert\"] {\n\t\tdisplay: block;\n\t}\n}\n\n// Enhanced input group accessibility\n.input_group-1 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: flex-start;\n\tgap: 8px;\n\t\n\t.lock-icon {\n\t\theight: 12px;\n\t\tcolor: var(--ion-color-medium);\n\t\t@include desktop {\n\t\t\tmargin: 2px -10px 15px 5px;\n\t\t}\n\t}\n\t\n\t&--1 {\n\t\twidth: 70% !important;\n\t\tmargin-right: 0;\n\t}\n\t\n\t&--2 {\n\t\tmargin: 0px 7px 20px;\n\t\twidth: 30% !important;\n\t}\n}\n\n.input_group-2 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: flex-start;\n\tpadding: 0 0px;\n\tgap: 8px;\n\n\t.lock-icon {\n\t\theight: 12px;\n\t\tcolor: var(--ion-color-medium);\n\t\t@include desktop {\n\t\t\tmargin: 2px -10px 15px 5px;\n\t\t}\n\t}\n\n\t&--1 {\n\t\twidth: 30%;\n\t\tmargin-right: 0;\n\t}\n\n\t&--2 {\n\t\twidth: 70%;\n\t\tmargin: 0 7px 20px;\n\t}\n}\n\n.option-name {\n\tlist-style: none;\n\t\n\tion-col {\n\t\tfont-size: 12px !important;\n\t\tcolor: #C1C1C1;\n\t\tpadding: 0px;\n\t}\n}\n\n// Enhanced item styling with better focus states\nion-item {\n\t--padding-start: 18px;\n\t--min-height: 45px;\n\t--border-radius: 16px;\n\t--background: white;\n\t--inner-border-width: 0px;\n\tborder: 1px solid #CBD5E1;\n\tmargin-bottom: 2px;\n\tborder-radius: 16px;\n\tmargin-top: 10px;\n\tfont-family: AppFontLight;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: #000000;\n\ttransition: all 0.2s ease;\n\n\t&:last-of-type {\n\t\tmargin-bottom: 0;\n\t}\n\t\n\t// Enhanced focus states\n\t&:focus-within {\n\t\tborder-color: var(--ion-color-primary);\n\t\tbox-shadow: 0 0 0 2px rgba(56, 128, 255, 0.2);\n\t}\n\t\n\t// Error state styling\n\t&[aria-invalid=\"true\"] {\n\t\tborder-color: #d32f2f;\n\t\t\n\t\t&:focus-within {\n\t\t\tborder-color: #d32f2f;\n\t\t\tbox-shadow: 0 0 0 2px rgba(211, 47, 47, 0.2);\n\t\t}\n\t}\n\t\n\t// Info state styling\n\t&.ion-info {\n\t\tborder-color: var(--ion-color-warning);\n\t\t\n\t\t&:focus-within {\n\t\t\tborder-color: var(--ion-color-warning);\n\t\t\tbox-shadow: 0 0 0 2px rgba(255, 193, 7, 0.2);\n\t\t}\n\t}\n\t\n\t// Disabled state\n\t&.disabled {\n\t\topacity: 0.6;\n\t\tcursor: not-allowed;\n\t\tbackground-color: #f5f5f5;\n\t}\n}\n\n// Enhanced input styling\nion-input {\n\tfont-family: AppFont, sans-serif;\n\tcolor: var(--ion-color-secondary);\n\tfont-size: 16px;\n\t\n\t&:focus-visible {\n\t\toutline: none; // Remove default outline since ion-item handles focus styling\n\t}\n\t\n\t&[readonly] {\n\t\tcursor: not-allowed;\n\t\tcolor: var(--ion-color-medium);\n\t}\n}\n\n.inputs_container__title {\n\tfont-size: 16px;\n}\n\n// Enhanced button wrapper accessibility\n.btn_wrapper {\n\tmargin: 0px;\n\ttext-align: center;\n\t\n\tp {\n\t\tfont-size: 12px;\n\t\ttext-align: center;\n\t\tcolor: var(--ion-color-primary);\n\t\tmargin-bottom: 8px;\n\t}\n\t\n\t.check_btn {\n\t\tmargin-top: 10px;\n\t\twidth: 80% !important;\n\t\tfont-size: 14px;\n\t\t--background: white;\n\t\tborder: 3px solid var(--ion-color-primary);\n\t\tcolor: var(--ion-color-primary);\n\t\ttransition: all 0.2s ease;\n\t\t\n\t\t&:hover:not([disabled]) {\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tcolor: white;\n\t\t\ttransform: translateY(-1px);\n\t\t}\n\t\t\n\t\t&:focus-visible {\n\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\t}\n}\n\n// Loading spinner accessibility\nion-spinner[aria-label] {\n\t// Ensure spinner is announced to screen readers\n\t&::after {\n\t\tcontent: attr(aria-label);\n\t\tposition: absolute;\n\t\tleft: -9999px;\n\t}\n}\n\n// Error container enhancements\n.error_container {\n\tmin-height: 20px; // Prevent layout shift when errors appear\n\t\n\tion-note {\n\t\ttransition: opacity 0.2s ease;\n\t\t\n\t\t&:not(.visible) {\n\t\t\topacity: 0;\n\t\t\theight: 0;\n\t\t\toverflow: hidden;\n\t\t}\n\t\t\n\t\t&.visible {\n\t\t\topacity: 1;\n\t\t\theight: auto;\n\t\t}\n\t}\n}\n\n// High contrast mode support\n@media (prefers-contrast: high) {\n\tion-item {\n\t\tborder-width: 2px;\n\t}\n\t\n\t.input-error, .error-text {\n\t\t--color: #cc0000 !important;\n\t\tfont-weight: 700;\n\t}\n\t\n\t:focus-visible {\n\t\toutline-width: 3px;\n\t}\n}\n\n// Reduced motion support\n@media (prefers-reduced-motion: reduce) {\n\t* {\n\t\tanimation-duration: 0.01ms !important;\n\t\tanimation-iteration-count: 1 !important;\n\t\ttransition-duration: 0.01ms !important;\n\t}\n\t\n\tion-button:hover:not([disabled]) {\n\t\ttransform: none;\n\t}\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
